import { Controller } from '@hotwired/stimulus'

// Shows the address field only when "delivery" is selected at checkout
export default class extends Controller {
  static targets = ['address', 'radio']

  connect() {
    this.toggle()
  }

  toggle() {
    const delivery = this.radioTargets.find((radio) => radio.checked)?.value === 'delivery'
    this.addressTarget.classList.toggle('hidden', !delivery)
  }
}
